export const EMPTY_LABEL = "—";

export const supplierTypeLabels = {
  furniture: "الأثاث بأنواعه",
  officeFurniture: "تجهيز مكاتب",
  curtains: "ستائر",
  carpets: "سجاد",
  kitchens: "مطابخ",
  interiorDecor: "منتجات الديكور الداخلية",
  flooring: "أرضيات",
  ceilings: "أسقف",
  homeAppliances: "أجهزة منزلية",
  buildingMaterials: "مواد بناء",
  concrete: "خرسانة",
  blocks: "بلك",
  sand: "رمل",
  asphalt: "اسفلت",
  cementProducts: "منتجات اسمنتية",
  structuralSteel: "هياكل إنشائية",
  panelBoards: "ألواح بانيل",
  steelIronProducts: "منتجات الحديد",
  woodProducts: "منتجات الخشب",
  foamProducts: "منتجات الفوم",
  stoneMarble: "حجر ورخام",
  tiles: "البلاط",
  ceramicPorcelain: "سيراميك وبورسلان",
  plumbing: "سباكة",
  sanitaryWare: "أدوات صحية",
  tanks: "خزانات",
  pipes: "أنابيب",
  pumps: "مضخات",
  electrical: "كهرباء",
  lighting: "إنارة",
  cables: "كيابل",
  electricGenerators: "مولدات كهرب",
  hvac: "تكييف وتهوية",
  heatingSystems: "أنظمة تدفئة",
  gasExtension: "تمديد غاز",
  sewageSystems: "الصرف الصحي",
  smartSystems: "أنظمة ذكية",
  safetyFirefightingSystems: "أنظمة السلامة ومكافحة الحرائق",
  securitySystems: "أنظمة أمنية",
  paints: "دهانات",
  insulation: "مواد العزل",
  gypsumBoard: "جبس بورد",
  cementBoard: "اسمنت بورد",
  gypsumProducts: "منتجات الجبس",
  doors: "أبواب بأنواعها",
  windows: "نوافذ",
  glass: "زجاج",
  aluminum: "ألمنيوم",
  elevatorsStaircases: "مصاعد وسلالم",
  treesPlants: "أشجار ونباتات",
  exteriorDecor: "منتجات الديكور الخارجية",
  awnings: "مظلات",
  advertisingSignboards: "لوحات إعلانية",
  containers: "حاويات",
  temporaryRentalRooms: "غرف التأجير المؤقت",
};

export const contractorSkillLabels = {
  interiorDesigner: "مصمم داخلي",
  restorationContractor: "مقاول ترميم",
  buildingContractor: "مقاول بناء",
  generalContractor: "مقاول عام",
  maintenanceAndCleanlinessContractor: "مقاول صيانة ونظافة",
  demolitionContractor: "مقاول هدم",
  excavationAndLevelingContractor: "مقاول حفر وتسوية",
};

export const statusLabels = {
  accepted: "مقبول",
  submitted: "تم الإرسال",
  pending: "قيد الانتظار",
  rejected: "مرفوض",
  completed: "مكتمل",
  active: "مفعل",
  inactive: "غير مفعل",
  chosen: "تم الاختيار",
  invoiced: "بفاتورة",
};

export const facilitySizeLabels = {
  verySmall: "صغيرة جداً",
  small: "صغيرة",
  medium: "متوسطة",
  large: "كبيرة",
};

export const measurementLabels = {
  meter: "متر",
  piece: "قطعة",
};

export const localizeValue = (value, labels, fallback = EMPTY_LABEL) => {
  if (value === null || value === undefined || value === "") return fallback;
  return labels[value] || value;
};

export const localizeList = (values, labels, separator = "، ") => {
  if (!Array.isArray(values) || values.length === 0) return EMPTY_LABEL;
  return values.map((value) => localizeValue(value, labels)).join(separator);
};

export const localizeSupplierType = (value) =>
  localizeValue(value, supplierTypeLabels);

export const localizeSupplierTypes = (values) =>
  localizeList(values, supplierTypeLabels);

export const localizeContractorSkill = (value) =>
  localizeValue(value, contractorSkillLabels, "غير محدد");

export const localizeContractorSkills = (values) =>
  localizeList(values, contractorSkillLabels);

export const localizeStatus = (value) => localizeValue(value, statusLabels, "-");

export const localizeFacilitySize = (value) =>
  localizeValue(value, facilitySizeLabels, "");

export const localizeMeasurement = (value) =>
  localizeValue(value, measurementLabels);
